import { useReactQuery } from '@ovotech/ui-tools';
import { createAddressLookupEndpoint } from '@/src/constants/endpoints';
import { apiService } from '@/src/services/api-service';
import { AddressLookupResponse } from '@/src/types/Address';
import { UseQueryOptions } from 'react-query';

function useAddressLookupQuery(
  postcode: string,
  options?: UseQueryOptions<AddressLookupResponse>,
) {
  return useReactQuery<AddressLookupResponse>(
    `gemini-journey-api-address-lookup-${postcode}`,
    () =>
      apiService
        .get<AddressLookupResponse>({
          url: createAddressLookupEndpoint(postcode),
        })
        .catch(err => {
          // 422 is no response which will return an empty array
          if (err?.response?.status === 422) {
            return [];
          }
          return Promise.reject(err);
        }),
    {
      enabled: !!postcode,
      ...options,
    },
  );
}

export { useAddressLookupQuery };
